export function SurveyComplete() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem 1.5rem',
      textAlign: 'center',
      background: 'var(--color-info-bg)',
    }}>
      <div style={{
        background: 'var(--color-surface)',
        borderRadius: 'var(--radius-xl)',
        padding: '2.5rem 2rem',
        maxWidth: 480,
        width: '100%',
        boxShadow: 'var(--shadow-md)',
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }} role="img" aria-label="Checkmark">✓</div>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.75rem' }}>Thank you</h1>
        <p style={{ color: 'var(--color-text-muted)', lineHeight: 1.6, marginBottom: '1rem' }}>
          Your response has been recorded. Only your team name was stored — no identifying
          information was written at any point.
        </p>
        <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)' }}>
          This survey link has been invalidated and cannot be reused.
        </p>
      </div>
    </div>
  );
}
